export default () => ({
  opened: false,
  open() {
    this.opened = true
    document.body.style.overflow = 'hidden';

    this.$nextTick(() => {
      this.returnFocus = this.$focus.lastFocused()
      this.$focus.first()
    })
  },
  close() {
    if(this.opened) {
      this.opened = false
      document.body.style.overflow = 'initial';

      this.$nextTick(() => {
        this.$focus.focus(this.returnFocus)
      })
    }
  }
})
